export const projectSolarSiteinfoChildrenRoutes = [
  {
    path: 'siteinfodetail',
    name: 'siteinfodetail',
    component: () => import('@/components/SiteInfoDetail/SiteInfoDetail.vue'),
    meta: {
      release: true,
      zhTw: '案場資訊',
      icon: 'fa fa-cloud',
      demoSite: true, // 展示案場可看
      foreignSite: false // 外來案場可看
    }
  },
  {
    path: 'devicestatus',
    name: 'devicestatus',
    component: () => import('@/components/DeviceStatus.vue'),
    meta: {
      release: true,
      zhTw: '裝置即時資訊',
      icon: 'fa fa-check-circle',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'devicehistory',
    name: 'devicehistory',
    component: () => import('@/components/DeviceHistory.vue'),
    meta: {
      release: true,
      zhTw: '裝置歷史資料',
      icon: 'fa fa-history',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'dataanalysis',
    name: 'dataanalysis',
    component: () => import('@/components/DataAnalysis.vue'),
    meta: {
      release: true,
      zhTw: '資料分析',
      icon: 'fa fa-flask',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'mpptanalysis',
    name: 'mpptanalysis',
    component: () => import('@/components/MpptAnalysis.vue'),
    meta: {
      release: true,
      zhTw: 'MPPT分析',
      icon: 'fa fa-bolt ',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'dataexcel',
    name: 'dataexcel',
    component: () => import('@/components/DataExcel.vue'),
    meta: {
      release: true,
      zhTw: '設計資訊',
      icon: 'fas fa-drafting-compass',
      demoSite: true,
      foreignSite: true
    }
  },
  {
    path: 'investmentanalysis',
    name: 'investmentanalysis',
    component: () => import('@/components/InvestmentAnalysis.vue'),
    meta: {
      release: true,
      zhTw: '投資分析',
      icon: 'fas fa-chart-line',
      demoSite: true,
      foreignSite: true
    }
  },
  {
    path: 'monthlyreport',
    name: 'monthlyreport',
    component: () => import('@/components/MonthlyReport.vue'),
    meta: {
      release: true,
      zhTw: '案場報表',
      icon: 'fas fa-file',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'otherinformation',
    name: 'otherinformation',
    component: () => import('@/components/OtherInformation.vue'),
    meta: {
      release: true,
      zhTw: '其他資訊',
      icon: 'fas fa-th-list',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'notificationsettings',
    name: 'notificationsettings',
    component: () => import('@/components/NotificationSettings.vue'),
    meta: {
      release: true,
      zhTw: '通知設定',
      icon: 'fas fa-bars',
      demoSite: true,
      foreignSite: false
    }
  },
  {
    path: 'didosettings',
    name: 'didosettings',
    component: () => import('@/components/DidoSettings.vue'),
    meta: {
      release: true,
      zhTw: 'DI/DO 資訊',
      icon: 'fas fa-cog',
      demoSite: true,
      foreignSite: false
    }
  }
]

export const projectSolarRoutes = [
  {
    path: 'realtime',
    name: 'realtime',
    component: () => import('@/views/Realtime.vue'),
    meta: {
      release: true, // 出現於 群組管理選項 (即時資訊不用設定勾選 任何權限皆有)
      zhTw: '即時資訊',
      keepAlive: true,
      icon: 'fas fa-home',
      showMenu: true // 出現於 左側選單 (展示電視牆 在群組管理選項 不在 sideMenu)
    }
  },
  {
    path: 'foreignfactories',
    name: 'foreignfactories',
    component: () => import('@/views/ForeignFactories.vue'),
    meta: {
      release: true,
      zhTw: '外來監控資訊',
      icon: 'fas fa-poll',
      showMenu: true
    }
  },
  {
    path: 'factorystatus',
    name: 'factorystatus',
    component: () => import('@/views/FactoryStatus.vue'),
    meta: {
      release: true,
      zhTw: '案場狀態',
      icon: 'fas fa-exclamation-circle',
      showMenu: true
    }
  },
  {
    path: 'historyalarms',
    name: 'historyalarms',
    component: () => import('@/views/HistoryAlarms.vue'),
    meta: {
      release: true,
      zhTw: '告警事件',
      icon: 'fa fa-bell',
      showMenu: true
    }
  },
  {
    path: 'usermanage',
    name: 'usermanage',
    component: () => import('@/views/UserManage.vue'),
    meta: {
      release: true,
      zhTw: '使用者管理',
      icon: 'fa fa-user',
      showMenu: true
    }
  },
  {
    path: 'groupmanage',
    name: 'groupmanage',
    component: () => import('@/views/GroupManage.vue'),
    meta: {
      release: true,
      zhTw: '群組管理',
      icon: 'fa fa-users',
      showMenu: true
    }
  },
  {
    path: 'emailsend',
    name: 'emailsend',
    component: () => import('@/views/EmailSend.vue'),
    meta: {
      release: true,
      zhTw: '信件補發',
      icon: 'fas fa-envelope',
      showMenu: true
    }
  },
  {
    path: 'multiplefactoryanalysis',
    name: 'multiplefactoryanalysis',
    component: () => import('@/views/MultipleFactoryAnalysis.vue'),
    meta: {
      release: true,
      zhTw: '跨案場分析',
      icon: 'fas fa-chart-line',
      showMenu: true
    }
  },
  {
    path: 'rawdatadownload',
    name: 'rawdatadownload',
    component: () => import('@/views/RawDataDownload.vue'),
    meta: {
      release: true,
      zhTw: '原始資料下載',
      icon: 'fas fa-solid fa-download',
      showMenu: true
    }
  },
  {
    path: 'aerialcomparison',
    name: 'aerialcomparison',
    component: () => import('@/views/AerialComparison.vue'),
    meta: {
      release: true,
      zhTw: '空拍比對資料下載',
      icon: 'fas fa-file-csv',
      showMenu: true
    }
  },
  {
    path: 'raanalysis',
    name: 'raanalysis',
    component: () => import('@/views/RaAnalysis.vue'),
    meta: {
      release: true,
      zhTw: 'RA 資料分析',
      icon: 'fas fa-solid fa-table',
      showMenu: true
    }
  },
  {
    path: 'kpireport',
    name: 'kpireport',
    component: () => import('@/views/KpiReport.vue'),
    meta: {
      release: true,
      zhTw: 'KPI 每月報告',
      icon: 'far fa-file-alt',
      showMenu: true
    }
  },
  {
    path: 'sortsetting',
    name: 'sortsetting',
    component: () => import('@/views/SortSetting.vue'),
    meta: {
      release: true,
      zhTw: '案場排序',
      icon: 'fas fa-sort-amount-up',
      showMenu: true
    }
  },
  {
    path: 'fuqiangxindemo',
    name: 'fuqiangxindemo',
    component: () => import('@/views/FuQiangXinDemo.vue'),
    meta: {
      release: true,
      zhTw: '富強鑫展示畫面',
      icon: 'fas fa-tachometer-alt',
      showMenu: true
    }
  },
  {
    path: 'tvwalllooping',
    name: 'tvwalllooping',
    component: () => import('@/views/TvWallLooping.vue'),
    meta: {
      release: true,
      zhTw: '電視牆輪播',
      icon: 'fas fa-desktop',
      showMenu: true
    }
  },
  {
    path: 'notification',
    name: 'notification',
    component: () => import('@/views/Notification.vue'),
    meta: {
      release: true,
      zhTw: '通知設定指南',
      icon: 'fas fa-book-open',
      showMenu: true
    }
  },
  {
    path: 'tvscreen',
    name: 'tvscreen',
    component: () => import('@/views/TvScreen.vue'),
    meta: {
      // authorize: [Role.Whole_Admin, Role.Admin],
      release: true,
      zhTw: '案場資訊 - 展示畫面(電視牆)',
      showMenu: false
    }
  },
  {
    path: 'siteinfo',
    name: 'siteinfo',
    component: () => import('@/views/SiteInfo.vue'),
    children: projectSolarSiteinfoChildrenRoutes
  }
]
